/* MEDIA PLAYER ITEM **********************************************************/
import React, {Component, PropTypes} from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { translate } from 'react-i18next'

import selector from './selector'

import DropdownButton from 'widget/dropdown-button'
import { Icon, ICON, SCHEME as ICON_SCHEME } from 'widget/icon'
import {
  RemoveDialog,
  SCHEME as REMOVE_DIALOG_SCHEME
} from 'widget/remove-dialog'

/* Actions */
import {
  bulkAssignPlaylist,
  bulkAssignAsset,
  bulkSync
} from 'react-redux/actions/media-player'

/* Styles */
import './bulk-edit.css'

/* A single MediaPlayer Device Item as shown in Media Player List */
class BulkEdit extends Component {

    constructor(props) {
      super(props)
      this.state = { isDropTarget: false, syncCommit: false, bookingCommit: false }
      this.dragEnterCount = 0
    }

    onDrop(e) {
      const {
        filter,
        globalFilter
      } = this.props
      e.preventDefault()
      try {
        const data = JSON.parse(e.dataTransfer.getData('text'))
        if(data.domain === "playlist" || data.domain === "asset") {
          this.setState({bookingCommit: true, bookingDomain: data.domain, bookingUid: data.uid})
        }
      } catch (e) {

      }
      this.setState({isDropTarget: false})
    }

    onDragEnter(e) {
      const { domain } = this.props.dragAndDrop
      e.preventDefault()
      e.stopPropagation()
      if (domain === 'asset' || domain === 'playlist') {
        this.setState({isDropTarget: true})
      } else {
        this.setState({isDropTarget: false})
      }
    }

    onDragOver(e) {
      const { domain } = this.props.dragAndDrop
      e.preventDefault()
      e.stopPropagation()
      if (domain === 'asset' || domain === 'playlist') {
        this.setState({isDropTarget: true})
      } else {
        this.setState({isDropTarget: false})
      }
    }

    onDragLeave(e) {
      e.preventDefault()
      this.setState({isDropTarget: false})
    }

    onSyncClick(e) {
      e.stopPropagation()
      this.setState({
        syncCommit: true
      })
    }

    onSyncCommitClick(e) {
      const { bulkSync, filter, globalFilter } = this.props
      e.preventDefault()
      this.setState({
        syncCommit: false
      })
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      bulkSync(filterString)
    }

    onSyncCancelClick(e) {
      e.stopPropagation()
      this.setState({
        syncCommit: false
      })
    }

    onBookingCommitClick(e) {
      const {
        bulkSync,
        filter,
        globalFilter,
        bulkAssignPlaylist,
        bulkAssignAsset,
      } = this.props
      const { bookingDomain, bookingUid } = this.state
      e.preventDefault()
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      if(bookingDomain === "playlist") {
        bulkAssignPlaylist( bookingUid, filterString)
      } else if (bookingDomain === "asset") {
        bulkAssignAsset( bookingUid, filterString)
      }
      this.setState({
        bookingCommit: false
      })
    }

    onBookingCancelClick(e) {
      e.stopPropagation()
      this.setState({
        bookingCommit: false
      })
    }

    getClassName() {
      const { } = this.props
      const { isDropTarget } = this.state
      var className = "bulk-edit component"
      if (isDropTarget) className += " drop-target"
      return className
    }

    getToolbarItems() {
      const { t, filter, globalFilter }  = this.props
      let items = [
        {
          name: t("mediaplayer:bulk.menu.syncLabel"),
          title: t("mediaplayer:bulk.menu.syncTitle"),
          icon: ICON.SYNC,
          iconScheme: ICON_SCHEME.DEFAULT,
          onClick: this.onSyncClick.bind(this)
        }
      ]
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")

      items.push({ type: "seperator" })
      items.push({
        name: filterString,
        title: "Filter",
        style: "info"
      })
      return items
    }

    measureHeight() {
      if(!this.mainElem) return null
      const bounds = this.mainElem.getBoundingClientRect()
      return bounds.height
    }

    renderSyncCommit() {
      const { t, filter, globalFilter }  = this.props
      const { syncCommit } = this.state
      if (!syncCommit) return null
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      return (
        <RemoveDialog
          text={ t("mediaplayer:bulk.syncDialog.text", {filterString}) }
          height={ this.measureHeight() }
          scheme={ REMOVE_DIALOG_SCHEME.ACTION }
          onCancel={ this.onSyncCancelClick.bind(this) }
          cancelLabel={ t("mediaplayer:bulk.syncDialog.cancelButtonLabel") }
          onConfirm={ this.onSyncCommitClick.bind(this) }
          confirmLabel={ t("mediaplayer:bulk.syncDialog.confirmButtonLabel") }
        />
      )
    }

    renderBookingCommit() {
      const { t, filter, globalFilter }  = this.props
      const { bookingCommit } = this.state
      if (!bookingCommit) return null
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      return (
        <RemoveDialog
          text={ t("mediaplayer:bulk.bookingDialog.text", {filterString}) }
          height={ this.measureHeight() }
          scheme={ REMOVE_DIALOG_SCHEME.ACTION }
          onCancel={ this.onBookingCancelClick.bind(this) }
          cancelLabel={ t("mediaplayer:bulk.bookingDialog.cancelButtonLabel") }
          onConfirm={ this.onBookingCommitClick.bind(this) }
          confirmLabel={ t("mediaplayer:bulk.bookingDialog.confirmButtonLabel") }
        />
      )
    }

    renderItemToolbar() {
      const { t } = this.props
      return (
        <span className="toolbar">
          <DropdownButton
            title={ t('mediaplayer:bulk.menuTitle') }
            menu={ { items:this.getToolbarItems() } }/>
        </span>
      )
    }

    renderProcessCount() {
      const { t, status, bulkSyncStatus } = this.props
      if (bulkSyncStatus.pending > 1 ) return (
        <div className="process-count">{ bulkSyncStatus.pending }</div>
      )
      return null
    }

    renderStatus() {
      const { t, status, bulkSyncStatus } = this.props
      if (bulkSyncStatus.pending>0) return (
        <div className="status-wrapper">
          <Icon
            className="online-icon"
            title={ t("mediaplayer:bulk.pendingSync") }
            icon={ ICON.LOADING_SYNC }
            size={ 32 }
            circle={ true }
            spin={ true }
            scheme={ ICON_SCHEME.ACTION }
            />
            { this.renderProcessCount() }
        </div>
      )
      return (
        <div className="status-wrapper">
          <Icon
            className="online-icon"
            title={ t("mediaplayer:bulk.ready") }
            icon={ ICON.HASHTAG }
            size={ 32 }
            circle={ true }
            scheme={ ICON_SCHEME.READY }
            />
        </div>
      )
    }


    render() {
      const { t, filter, globalFilter }  = this.props
      const filterString = _.compact(
        [filter.expression, globalFilter.expression]
      ).join(" ")
      return (
        <li
          key="bulkEdit"
          className={ this.getClassName() }
        >
          <div
              className="content"
              ref={ (elem) => { this.mainElem = elem } }
              onDragEnter={ this.onDragEnter.bind(this) }
              onDragOver={ this.onDragOver.bind(this) }
              onDragLeave={ this.onDragLeave.bind(this) }
              onDrop={ this.onDrop.bind(this) }
          >
            <div className="border">
              <div className="detail">
                <div className="status">
                  { this.renderStatus() }
                </div>
                <div className="info">
                  <div className="label">{t("mediaplayer:bulk.name")}</div>
                  <div className="label">
                    <span>{ t("mediaplayer:bulk.filter", { filterString }) }</span>
                  </div>
                </div>
                { this.renderItemToolbar() }
              </div>
            </div>
            { this.renderSyncCommit() }
            { this.renderBookingCommit() }
          </div>
        </li>
      )
    }
}

BulkEdit.propTypes =  {
}


const mapStateToProps = (state, props) => {
  return {
    dragAndDrop: state.dragAndDrop,
    filter: state.mediaPlayer.list.filter,
    globalFilter: state.app.filter,
    bulkSyncStatus: state.mediaPlayer.list.bulkSync
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      bulkAssignPlaylist,
      bulkAssignAsset,
      bulkSync
    },
    dispatch
  )
}

const reduxComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(BulkEdit)
export default translate([], { withRef: true })(reduxComponent)



// WEBPACK FOOTER //
// ./src/app/component/media-player/bulk-edit.jsx